module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC42NjY2MjYgNy4zMzMyOUw3LjMzMzI5IDAuNjY2NjI2TTcuMzMzMjkgMC42NjY2MjZIMC42NjY2MjZNNy4zMzMyOSAwLjY2NjYyNlY3LjMzMzI5IiBzdHJva2U9IiM0OUIzQjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/external_arrow_teal.svg
// module id = 3531
// module chunks = 0